// Contrato de runtime para el build de la intranet. Webpack (Nuxt 2) no compila de forma fiable
// imports .mjs cross-package fuera de rootDir, así que la intranet lleva su copia local.
// Fuente canónica: scripts/appliers/config-{version,contract}.mjs. El test de drift
// scripts/__tests__/config-contract-sync.test.mjs falla si CONFIG_VERSION diverge (C3).

export const CONFIG_VERSION = 1;

const isNonEmptyString = (value) => typeof value === "string" && value.trim() !== "";
const HEX_PATTERN = /^#[0-9A-Fa-f]{6}$/;
// isPlainObject: descarta null y arrays (typeof null === 'object' y typeof [] === 'object').
const isPlainObject = (value) =>
	typeof value === "object" && value !== null && !Array.isArray(value);

export const validateRuntimeConfig = (config, expectedVersion = CONFIG_VERSION) => {
	if (!config || typeof config !== "object" || Array.isArray(config)) {
		return { ok: false, reason: "config.json no es un objeto" };
	}
	if (config.configVersion !== expectedVersion) {
		return {
			ok: false,
			reason: `configVersion ${config.configVersion} incompatible con el bundle (espera ${expectedVersion})`,
		};
	}
	if (!config.api || !isNonEmptyString(config.api.url)) {
		return { ok: false, reason: "config.api.url ausente o vacío" };
	}
	if (!config.colors || !HEX_PATTERN.test(config.colors.primary ?? "")) {
		return { ok: false, reason: "config.colors.primary no es un color hex válido" };
	}
	if (!Array.isArray(config.services)) {
		return { ok: false, reason: "config.services no es un array" };
	}
	// features es OPCIONAL y aditivo: ausente ⇒ ok; presente ⇒ debe ser objeto plano.
	if (config.features !== undefined && !isPlainObject(config.features)) {
		return { ok: false, reason: "config.features no es un objeto plano" };
	}
	return { ok: true };
};
